import { LS_get, LS_remove, LS_set } from './LS'
import type { User_IUser } from '../User/User.IUser'

export function LS_userGet(): User_IUser {
    return LS_get('user')
}

export function LS_userSet(user: User_IUser) {
    LS_set('user', user)
}

export function LS_userRemove() {
    LS_remove('user')
}
